(function() {
    angular
        .module("app")
        .controller("DuplicateDeviceIpModalController", DuplicateDeviceIpModalController)

    DuplicateDeviceIpModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "duplicateDevices",
        "createDuplicate",
        "actionText"
    ]

    function DuplicateDeviceIpModalController(
        $scope,
        $uibModalInstance,
        duplicateDevices,
        createDuplicate,
        actionText
    ){
        "use strict"

        $scope.duplicateDevices = duplicateDevices
        $scope.actionText       = actionText

        $scope.ok = function() {
            createDuplicate()
            $uibModalInstance.close()
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
